import { DIALOGS } from '@/constants/dialogs';

export const SHORTCUT_KEYS = {
  '\\U': DIALOGS.USER,
  '\\C': DIALOGS.COMPANY,
  '\\I': DIALOGS.INVESTOR,
  '\\M': DIALOGS.COMPANY_MEMBER,
} as const;

export type ShortcutKey = keyof typeof SHORTCUT_KEYS;
